'use client'

import { registerGuestReferralCode, registerReferralCode } from '@/actions/authentication';
import Button from '@/components/ui/Button';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import useToast from '@/hooks/useToast';
import Cookies from 'js-cookie';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export default function RegisterReferralCode({ onSuccess, onError, }: { onSuccess: () => void, onError: (message: string) => void, }) {
    const [email, setEmail] = useState('')
    const [isSending, setIsSending] = useState(false)
    const { warningToast } = useToast()


    const { params: { referral_code } } = useSetSearchParams()

    useEffect(() => {
        if (referral_code) {
            setEmail(referral_code)
        }
    }, [referral_code])


    const router = useRouter()

    const send = async (e: any) => {

        setIsSending(true)
        e.preventDefault()
        const uuid = uuidv4()
        const res = await registerGuestReferralCode(email.trim(), uuid)
        const { result, response } = JSON.parse(res)

        if (response.ok) {
            Cookies.set('referralUUID', uuid, { expires: 365 })
            onSuccess()
            router.refresh()

        } else {
            onError(result.message)
        }

        setIsSending(false)

    }

    return (
        <div className='border rounded-3xl p-4 max-w-xl'>
            <div className='flex items-center gap-4 mb-4'>
                <Image
                    width={50}
                    height={50}
                    alt='gift'
                    className='w-7'
                    src={`${process.env.NEXT_PUBLIC_STORAGE_URL}avatar/f636ecc7-525b-4774-af56-26fafcf005da-planingo.png`}
                />
                <p className='text-base text-gray-800 font-semibold'>Referral code</p>
            </div>
            <form onSubmit={send} className='grid md:grid-cols-[1fr,_auto] gap-2 w-full mt-4'>
                <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder='Enter Your code'
                    className='rounded-xl text-sm font-normal px-4 py-2 border placeholder:text-sm placeholder:font-normal' />
                <Button isLoading={isSending} disabled={!email} color='secondary'>
                    Unlock My Prices
                </Button>
            </form>
        </div>
    );
}